import i18n from 'i18next';

export const NEUTRAL = 'neutral';

const getGenderFormatted = gender => {
  if (!gender || gender === NEUTRAL) {
    return '';
  }

  return i18n.t(`global:gender:${gender}`);
};

export default getGenderFormatted;
